// import { usePageTitle } from '../hooks/usePageTitle';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import Pagination from '../utilities/Pagination';
import serviceSampleImg from "../assets/defaults/Profile-Sample0.jpg";
import formatTitleForUrl from '../utilities/formatTitleForUrl';
import { useMetadata } from "../hooks/useMetadata";

export default function AdvancedServices() {
    const { t, i18n } = useTranslation();
    const [advanceServiceData, setAdvancedServicesData] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState(null);
    const totalPages = advanceServiceData?.data?.paginationInfo.totalPagesCount;

    // usePageTitle('AdvancedServices');
    useMetadata(i18n.language);

    useEffect(() => {
        async function fetchAdvServices() {
            try {
                const data = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/services?page=${currentPage}&limit=6&type=advanced`, {
                    method: "GET",
                    headers: {
                        "accept": "*/*"
                    },
                    body: JSON.stringify()
                });
                const responseData = await data.json();
                setAdvancedServicesData(responseData);
            } catch (err) {
                setError(t("errorGetData"));
            }
        }

        fetchAdvServices();
    }, [currentPage, t]);


    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!advanceServiceData) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    if (advanceServiceData?.data?.result.length === 0) {
        return (i18n.language === "ar" ?
            <p className="text-center my-3 mx-auto rounded p-2 bg-light-beige text-white w-75">  ستجد العديد من الخدمات هنا قريبا</p> :
            <p className="text-center my-3 mx-auto rounded p-2 bg-light-beige text-white w-75">You will find many services here soon</p>);
    }

    return (
        <div className="container mt-4">
            <div className="d-flex flex-wrap justify-content-evenly pt-1 align-content-start">
                {advanceServiceData?.data?.result.map((service) => (
                    <div key={service.id} className="admin-profile-img col-12 col-md-4 p-1 position-relative p-3">
                        <p className="position-absolute bottom-0 start-50 mb-4 p-2 translate-middle-x bg-white w-75 text-center rounded">
                            {/* {service.name} */}
                            {i18n.language === "ar" ? service.nameAr : service.name}
                        </p>
                        <Link
                            to={`/${i18n.language}/advancedServices/${service.id}/${formatTitleForUrl(i18n.language === "ar" ? service.nameAr : service.name)}`}
                            key={service.id} className="text-decoration-none">
                            <img
                                crossOrigin="anonymous"
                                src={service.thumbnail ? service.thumbnail : serviceSampleImg}
                                alt={`Service ${service.id}`}
                                className="rounded-4 w-100 border" />
                        </Link>
                    </div>
                ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }

        </div>
    );
};
